import Vue from "vue";

type AlertState = {
  showAlert: boolean;
  alertMessage: string;
  alertType: string;
};

const AlertClass = {
  Info: "info",
  Success: "alert-success",
  Error: "alert-danger",
} as const;

type AlertClassType = typeof AlertClass[keyof typeof AlertClass];

const alertState = Vue.observable<AlertState>({
  showAlert: false,
  alertMessage: "",
  alertType: "",
});

let alertTimer: ReturnType<typeof setTimeout> | null = null;

const hide = (): void => {
  alertState.showAlert = false;
};

const show = (message: string, type: AlertClassType = AlertClass.Info): void => {
  if (alertTimer) {
    clearTimeout(alertTimer);
  }

  alertState.alertMessage = message;
  alertState.alertType = type;
  alertState.showAlert = true;

  alertTimer = setTimeout(() => {
    hide();
    alertTimer = null;
  }, 3000);
};

export const alert = {
  hide,
  showInfo(message: string): void {
    show(message, AlertClass.Info);
  },
  showSuccess(message: string): void {
    show(message, AlertClass.Success);
  },
  showError(message: string): void {
    show(message, AlertClass.Error);
  },
};

export default {
  computed: {
    showAlert(): boolean {
      return alertState.showAlert;
    },
    alertMessage(): string {
      return alertState.alertMessage;
    },
    alertType(): string {
      return alertState.alertType;
    },
  },

  methods: {
    hideAlert(): void {
      alert.hide();
    },
  },
};
